import * as React from "react";
import type { SVGProps } from "react";
const SvgRemoveSolidIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="remove_solid_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M981.333 512c0 259.2-210.133 469.333-469.333 469.333S42.667 771.2 42.667 512 252.8 42.667 512 42.667 981.333 252.8 981.333 512zm-640-42.667a42.667 42.667 0 1 0 0 85.334h341.334a42.667 42.667 0 1 0 0-85.334H341.333z"
    />
  </svg>
);
export default SvgRemoveSolidIcon;
